import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeDivision = async () => {
  return await axios.get(`${api_base_url}/OfficeDivision`).then((results) => {
    if (results) {
      return results.data;
    }
  });
};
export const addOfficeDivision = async (newOfficeDivision) => {
  const { data } = await axios.post(`${api_base_url}/OfficeDivision`, {
    ...newOfficeDivision[0],
  });
  return data;
};
export const updateOfficeDivision = async (updatedOfficeDivision) => {
  const { data } = await axios.put(
    `${api_base_url}/OfficeDivision/${updatedOfficeDivision[0].divisionId}`,
    updatedOfficeDivision[0]
  );
  return data;
};

export const deleteOfficeDivision = async (ids) => {
  await axios.delete(`${api_base_url}/OfficeDivision/`, {
    data: ids,
  });
};

export const searchOfficeDivision = async (searchInputsData) => {
  if (searchInputsData === "") {
    searchInputsData = "0";
  }
  const data = {
    mas500id: parseInt(searchInputsData),
  };

  return await axios
    .post(`${api_base_url}/OfficeDivision/SearchOfficeDivision`, data)
    .then((res) => res.data);
};
